export default ({ tag }) => ({
  nodes: [
    {
      match: { type: `${tag}_min` },
      min: 1,
      max: 1,
    },
    {
      match: { type: `${tag}_max` },
      min: 1,
      max: 1,
    },
  ],
});
